import request from '@/utils/request'

export function updatePayWhiteCfg(data) {
  return request({
    url: 'api/v1/payWhite/updateCfg',
    method: 'post',
    data: data
  })
}

export function gePayWhiteCfg(data) {
  return request({
    url: 'api/v1/payWhite/getCfg',
    method: 'get',
    data: data
  })
}
